<div *ngIf="selectedProgramType !== 'Alumni'" class="w-full  flex flex-column border-1 border-300 border-round-lg align-items-center">
    <div class="w-full flex-column p-4 flex gap-3">
        <h2 class="text-left font-medium text-xl" style="color: #000086;">Rankings</h2>
        <div class="grid align-items-start">
            <div class="col-12 sm:col-4 flex flex-column gap-1 ">
                <p class="font-medium text-base font-semibold text-bluegray-600">QS World Ranking </p>
                <b class="font-semibold text-xl">#{{institute?.qsRanking}}</b>
            </div>
            <div class="col-12 sm:col-4 flex flex-column gap-1">
                <p class="font-medium text-base font-semibold text-bluegray-600">US Ranking</p>
                <b class="font-semibold text-xl">#{{institute?.countryRanking}}</b>
            </div>
            <div *ngIf="selectedProgramType === 'Bachelor\'s Degree'  && institute?.usNewsRanking"
                class="col-12 sm:col-4 flex flex-column gap-1">
                <p class="font-medium text-base font-semibold text-bluegray-600">US News Ranking</p>
                <b class="font-semibold text-xl">#{{institute?.usNewsRanking}}</b>
            </div>
            <div *ngIf="institute?.subjectRanks && (institute?.subjectRanks | keyvalue)?.length"
                class="col-12 sm:col-4 flex flex-column gap-1 ">
                <p class="font-medium text-base font-semibold text-bluegray-600">Subject Ranks</p>
                <div class="font-semibold text-xl" *ngFor="let subjectRank of institute?.subjectRanks | keyvalue">
                    {{subjectRank.key}}: #{{subjectRank.value}}</div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="selectedProgramType !== 'Alumni'" id="divFacilities" class="w-full mt-3 flex flex-column border-1 border-300 border-round-lg p-4 gap-3">
    <h2 class="text-left font-medium text-xl m-0" style="color: #000086;">Facilities</h2>
    <div *ngIf="institute?.facilities?.sportsFacilities || institute?.facilities?.swimmingPool || institute?.facilities?.gym; else noFacilities" 
         class="flex flex-wrap gap-5">
        
        <div *ngIf="institute?.facilities?.sportsFacilities" class="flex flex-column align-items-center gap-2">
            <div class="flex align-items-center justify-content-center border-circle shadow-1" style="width: 3.5rem; height: 3.5rem; background-color: #000086;">
                <i class="pi pi-trophy text-white text-xl"></i>
            </div>
            <div class="text-center">
                <p class="font-bold m-0" style="color: #12263F;">Sports Facilities</p>
                <p class="text-sm text-bluegray-400 m-0">Available</p>
            </div>
        </div>

        <div *ngIf="institute?.facilities?.swimmingPool" class="flex flex-column align-items-center gap-2">
            <div class="flex align-items-center justify-content-center border-circle shadow-1" style="width: 3.5rem; height: 3.5rem; background-color: #000086;">
                <i class="pi pi-map text-white text-xl"></i>
            </div>
            <div class="text-center">
                <p class="font-bold m-0" style="color: #12263F;">Swimming Pool</p>
                <p class="text-sm text-bluegray-400 m-0">Available</p>
            </div>
        </div>

        <div *ngIf="institute?.facilities?.gym" class="flex flex-column align-items-center gap-2">
            <div class="flex align-items-center justify-content-center border-circle shadow-1" style="width: 3.5rem; height: 3.5rem; background-color: #000086;">
                <i class="pi pi-bolt text-white text-xl"></i>
            </div>
            <div class="text-center">
                <p class="font-bold m-0" style="color: #12263F;">Gym</p>
                <p class="text-sm text-bluegray-400 m-0">Available</p>
            </div>
        </div>

    </div>
    <ng-template #noFacilities>
        <div class="flex align-items-center gap-2 text-bluegray-400 py-2">
            <i class="pi pi-info-circle text-xl"></i>
            <span>No facilities information available.</span>
        </div>
    </ng-template>
</div>

<app-institute-detail-alumni
  *ngIf="selectedProgramType === 'Alumni'"
  [institute]="institute">
</app-institute-detail-alumni>

<div *ngIf="selectedProgramType === 'Bachelor\'s Degree'" id="divAdmissions"
    class="w-full mt-3 flex flex-column border-1 border-300 border-round-lg align-items-center">
    <div class="w-full p-4 flex flex-column gap-3">
        <h2 class="text-left text-2xl font-medium" style="color: #000086;">Admissions</h2>
        <div class="w-full flex justify-content-between">
            <div class="flex flex-column gap-1" *ngIf="isUGDetails(instituteUGMDetails)">
                <p class="text-lg text-bluegray-600">Acceptance Rate</p>
                <b class="text-2xl font-bold">{{ formatPercent(instituteUGMDetails.acceptanceRate) ?? 'N/A' }}</b>
            </div>
            <div *ngIf="isUGDetails(instituteUGMDetails)" class="flex flex-column gap-1">
                <p class="text-lg text-bluegray-600">Application Deadline - Regular Decision</p>
                <b class="text-2xl font-bold">{{ instituteUGMDetails.applicationDeadlineRegularDecision ?? 'N/A'}}</b>
            </div>
        </div>

        <div class="flex gap-3 md:gap-6 flex-column md:flex-row">
            <div class="flex-1 flex flex-column gap-3">
                <div class="flex flex-column">
                    <div *ngIf="isUGDetails(instituteUGMDetails)"
                        class="flex align-items-center justify-content-between border-y-1 border-300 py-3">
                        <p class="text-base font-semibold font-semibold text-bluegray-600">Application fee 2023</p>
                        <p class="text-base font-semibold font-medium" style="color: #12263F;">{{
                            getAmount(instituteUGMDetails.currency, ( instituteUGMDetails.applicationFees ?? '0') ||
                            '0') }}</p>
                    </div>
                    <div *ngIf="isMastersDetails(instituteUGMDetails)"
                        class="flex align-items-center justify-content-between border-y-1 border-300 py-3">
                        <p class="text-base font-semibold text-bluegray-600">Application fee 2023</p>
                        <p class="text-base font-semibold font-medium" style="color: #12263F;">{{
                            getAmount(instituteUGMDetails.currency, ( instituteUGMDetails.applicationFees ?? '0') ||
                            '0') }}</p>
                    </div>
                    <div *ngIf="isUGDetails(instituteUGMDetails)"
                        class="flex align-items-center justify-content-between border-y-1 border-300 py-3">
                        <p class="text-base font-semibold text-bluegray-600">Total Applicants</p>
                        <p class="text-base font-semibold font-medium" style="color: #12263F;">
                            {{instituteUGMDetails.totalApplicants === 0 || null ? 'N/A' :
                            instituteUGMDetails.totalApplicants | number}}</p>
                    </div>
                    <div *ngIf="isUGDetails(instituteUGMDetails)"
                        class="flex align-items-center justify-content-between border-y-1 border-300 py-3">
                        <p class="text-base font-semibold text-bluegray-600">High-School GPA Requirement</p>
                        <p class="text-base font-semibold font-medium" style="color: #12263F;">
                            {{instituteUGMDetails.secondarySchoolGPARequirement??''}}</p>
                    </div>
                    <div *ngIf="isUGDetails(instituteUGMDetails)"
                        class="flex align-items-center justify-content-between border-y-1 border-300 py-3">
                        <p class="text-base font-semibold text-bluegray-600">Personal Statement or Essay</p>
                        <p class="text-base font-semibold font-medium" style="color: #12263F;">
                            {{instituteUGMDetails.personalStatementOrEssayRequirement??''}}</p>
                    </div>
                    <div *ngIf="isUGDetails(instituteUGMDetails)"
                        class="flex align-items-center justify-content-between border-y-1 border-300 py-3">
                        <p class="text-base font-semibold text-bluegray-600">Work Experience</p>
                        <p class="text-base font-semibold font-medium" style="color: #12263F;">
                            {{instituteUGMDetails.workExperienceRequirement ?? 'N/A'}}</p>
                    </div>
                    <!-- <div *ngIf="isUGDetails(instituteUGMDetails)" class="flex align-items-center justify-content-between border-y-1 border-300 py-3">
                        <p class="text-base font-semibold text-bluegray-600">Admission Test Scores</p>
                        <p class="text-base font-semibold font-medium" style="color: #12263F;">{{instituteUGMDetails.admissionTestScoresRequirements ?? 'N/A'}}</p>  
                    </div> -->
                    <div *ngIf="isUGDetails(instituteUGMDetails)"
                        class="flex align-items-center justify-content-between border-y-1 border-300 py-3">
                        <p class="text-base font-semibold text-bluegray-600">Recommendations</p>
                        <p class="text-base font-semibold font-medium" style="color: #12263F;">
                            {{instituteUGMDetails.recommendations ?? 'N/A'}}</p>
                    </div>
                    <!-- <div *ngIf="isUGDetails(instituteUGMDetails)"  class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
                        <p class="text-sm text-bluegray-600">Application Deadline - Early Action</p>        
                        <p class="text-sm font-medium" style="color: #12263F;">{{ instituteUGMDetails.applicationDeadlineEarlyAction ?? 'N/A'}}</p>
                    </div>
                    <div  *ngIf="isUGDetails(instituteUGMDetails)"  class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
                        <p class="text-sm text-bluegray-600">Application Deadline - Early Decision</p>
                        <p class="text-sm font-medium" style="color: #12263F;">{{ instituteUGMDetails.applicationDeadlineEarlyDecisionOne ?? 'N/A'}}</p>
                    </div> -->
                    <!-- <div *ngIf="isUGDetails(instituteUGMDetails)"  class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
                        <p class="text-sm text-bluegray-600">Total Applicants</p>
                        <p class="text-sm font-medium" style="color: #12263F;">{{ instituteUGMDetails.totalApplicants ?? 'N/A'}}</p>
                    </div>       -->
                    <!-- <div *ngIf="isUGDetails(instituteUGMDetails)"  class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
                        <p class="text-sm text-bluegray-600">SAT Evidence-Based Reading and Writing 50th percentile score</p>
                        <p class="text-sm font-medium" style="color: #12263F;">{{ instituteUGMDetails.fiftythSATEvidenceBasedReadingAndWritingPercentileScore ?? 'N/A'}}</p>
                    </div> -->
                    <!-- <div *ngIf="isUGDetails(instituteUGMDetails)"   class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
                        <p class="text-sm text-bluegray-600">SAT Math 50th percentile score</p>
                        <p class="text-sm font-medium" style="color: #12263F;">{{ instituteUGMDetails.fiftythSATMathPercentileScore ?? 'N/A'}}</p>
                    </div>
                    <div *ngIf="isUGDetails(instituteUGMDetails)"   class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
                        <p class="text-sm text-bluegray-600">Midpoint overall SAT score</p>
                        <p class="text-sm font-medium" style="color: #12263F;">{{ instituteUGMDetails.midpointOverallSATScore ?? 'N/A'}}</p>
                    </div>
                    <div *ngIf="isUGDetails(instituteUGMDetails)"   class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
                        <p class="text-sm text-bluegray-600">ACT Composite 50th percentile score</p>
                        <p class="text-sm font-medium" style="color: #12263F;">{{ instituteUGMDetails.fiftythACTCompositePercentileScore ?? 'N/A'}}</p>
                    </div>
                    <div *ngIf="isUGDetails(instituteUGMDetails)"   class="flex align-items-center justify-content-between border-300 pt-3">
                        <p class="text-sm text-bluegray-600">ACT English 50th percentile score</p>
                        <p class="text-sm font-medium" style="color: #12263F;">{{ instituteUGMDetails.fiftythACTEnglishPercentileScore ?? 'N/A'}}</p>
                    </div>
                    <div *ngIf="isUGDetails(instituteUGMDetails)"   class="flex align-items-center justify-content-between border-300 pt-3">
                        <p class="text-sm text-bluegray-600">Midpoint of the ACT math score</p>
                        <p class="text-sm font-medium" style="color: #12263F;">{{ instituteUGMDetails.midpointOfACTMathScore ?? 'N/A'}}</p>
                    </div>
                    <div *ngIf="isUGDetails(instituteUGMDetails)"   class="flex align-items-center justify-content-between border-300 pt-3">
                        <p class="text-sm text-bluegray-600">Percent of first-time degree/certificate-seeking students submitting SAT scores</p>
                        <p class="text-sm font-medium" style="color: #12263F;">{{ instituteUGMDetails.percentageOfFirstTimeDegreeOrCertificateSeekingStudentsSubmittingSATScore ?? 'N/A'}}</p>
                    </div>
                    <div *ngIf="isUGDetails(instituteUGMDetails)"   class="flex align-items-center justify-content-between border-300 pt-3">
                        <p class="text-sm text-bluegray-600">English Language requirement</p>
                        <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.englishLanguageRequirement ?? 'N/A'}}</p>
                    </div> -->
                </div>
            </div>
            <div class="flex-1 flex flex-column gap-3">
                <div *ngIf="isUGDetails(instituteUGMDetails)" class="flex flex-column">
                    <div class="flex align-items-center justify-content-between border-y-1 border-300 py-3">
                        <p class="text-base font-semibold text-bluegray-600">Application Deadline - Early Action</p>
                        <p class="text-base font-semibold font-medium" style="color: #12263F;">
                            {{instituteUGMDetails.applicationDeadlineEarlyAction}}</p>
                    </div>
                    <div class="flex align-items-center justify-content-between border-y-1 border-300 py-3">
                        <p class="text-base font-semibold text-bluegray-600">Average ACT Score</p>
                        <p class="text-base font-semibold font-medium" style="color: #12263F;">
                            {{instituteUGMDetails.fiftythACTCompositePercentileScore | number}}</p>
                    </div>
                    <div class="flex align-items-center justify-content-between border-y-1 border-300 py-3">
                        <p class="text-base font-semibold text-bluegray-600">Average SAT Score</p>
                        <p class="text-base font-semibold font-medium" style="color: #12263F;">
                            {{instituteUGMDetails.midpointOverallSATScore | number}}</p>
                    </div>
                    <div class="flex align-items-center justify-content-between border-y-1 border-300 py-3">
                        <p class="text-base font-semibold text-bluegray-600">Mean SAT Critical Reading Scores</p>
                        <p class="text-base font-semibold font-medium" style="color: #12263F;">
                            {{instituteUGMDetails.fiftythSATEvidenceBasedReadingAndWritingPercentileScore | number}}</p>
                    </div>
                    <div class="flex align-items-center justify-content-between border-y-1 border-300 py-3">
                        <p class="text-base font-semibold text-bluegray-600">Mean SAT Math Score</p>
                        <p class="text-base font-semibold font-medium" style="color: #12263F;">
                            {{instituteUGMDetails.fiftythSATMathPercentileScore | number}}</p>
                    </div>
                    <div class="flex align-items-center justify-content-between border-y-1 border-300 py-3">
                        <p class="text-base font-semibold text-bluegray-600">Mean ACT Math Score</p>
                        <p class="text-base font-semibold font-medium" style="color: #12263F;">
                            {{instituteUGMDetails.midpointOfACTMathScore | number}}</p>
                    </div>
                    <div class="flex align-items-center justify-content-between border-y-1 border-300 py-3">
                        <p class="text-base font-semibold text-bluegray-600">Mean ACT English Score</p>
                        <p class="text-base font-semibold font-medium" style="color: #12263F;">
                            {{instituteUGMDetails.fiftythACTEnglishPercentileScore | number}}</p>
                    </div>
                    <!-- <div  class="flex align-items-center justify-content-between border-y-1 border-300 py-3">
                        <p class="text-sm text-bluegray-600">Percent of first-time degree/certificate-seeking students submitting ACT scores</p>
                        <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.totalApplicants}}</p>
                    </div>
                    <div class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
                        <p class="text-sm text-bluegray-600">Secondary School GPA</p>
                        <p class="text-sm font-medium" style="color: #12263F;">{{ instituteUGMDetails.secondarySchoolGPARequirement ?? 'N/A'}}</p>
                    </div>
                    <div class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
                        <p class="text-sm text-bluegray-600">Secondary school rank</p>
                        <p class="text-sm font-medium" style="color: #12263F;">{{ instituteUGMDetails.secondarySchoolRankRequirement ?? 'N/A'}}</p>
                    </div>
                    <div class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
                        <p class="text-sm text-bluegray-600">Secondary school record</p>
                        <p class="text-sm font-medium" style="color: #12263F;">{{ instituteUGMDetails.secondarySchoolRecordRequirement ?? 'N/A'}}</p>
                    </div>
                    <div class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
                        <p class="text-sm text-bluegray-600">Completion of college-preparatory program</p>
                        <p class="text-sm font-medium" style="color: #12263F;">{{ instituteUGMDetails.completionOfCollegePreparatoryProgramRequirement ?? 'N/A'}}</p>
                    </div>
                    <div class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
                        <p class="text-sm text-bluegray-600">Recommendations</p>
                        <p class="text-sm font-medium" style="color: #12263F;">{{ instituteUGMDetails.recommendations ?? 'N/A'}}</p>
                    </div>
                    <div class="flex align-items-center justify-content-between border-300 pt-3">
                        <p class="text-sm text-bluegray-600">Formal demonstration of competencies</p>
                        <p class="text-sm font-medium" style="color: #12263F;">{{ instituteUGMDetails.formalDemonstrationOfCompetenciesRequirement ?? 'N/A'}}</p>
                    </div>
                    <div class="flex align-items-center justify-content-between border-300 pt-3">
                        <p class="text-sm text-bluegray-600">Work experience</p>
                        <p class="text-sm font-medium" style="color: #12263F;">{{ instituteUGMDetails.workExperienceRequirement ?? 'N/A'}}</p>
                    </div>
                    <div class="flex align-items-center justify-content-between border-300 pt-3">
                        <p class="text-sm text-bluegray-600">Personal statement or essay</p>
                        <p class="text-sm font-medium" style="color: #12263F;">{{ instituteUGMDetails.personalStatementOrEssayRequirement ?? 'N/A'}}</p>
                    </div>
                    <div class="flex align-items-center justify-content-between border-300 pt-3">
                        <p class="text-sm text-bluegray-600">Legacy status</p>
                        <p class="text-sm font-medium" style="color: #12263F;">{{ instituteUGMDetails.legacyStatusRequirement ?? 'N/A'}}</p>
                    </div>
                    <div class="flex align-items-center justify-content-between border-300 pt-3">
                        <p class="text-sm text-bluegray-600">Admission test scores</p>
                        <p class="text-sm font-medium" style="color: #12263F;">{{ instituteUGMDetails.admissionTestScoresRequirements ?? 'N/A'}}</p>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="selectedProgramType === 'Master\'s Degree' && isMastersDetails(instituteUGMDetails)" id="divCost"
    class="w-full  mt-3  flex flex-column border-1 border-300 border-round-lg align-items-center">
    <div class="flex flex-column gap-3 w-full p-4">
        <h2 class="text-left text-xl font-medium" style="color: #000086;">Cost</h2>
        <div class="flex gap-6 flex-column md:flex-row">
            <div class="flex-1 flex flex-column gap-3">
                <div class="flex flex-column gap-3">

                    <div class="flex align-items-center justify-content-between gap-2">
                        <div class="flex flex-column gap-1">
                            <p class="text-base font-semibold font-medium text-bluegray-600">Net Price</p>
                            <b class="text-2xl font-bold">{{ getAmount(instituteUGMDetails.currency,
                                ( instituteUGMDetails.tutionFees ?? 0) || 0) }}</b>
                        </div>
                        <div *ngIf="institute?.netPriceCalculator && institute?.netPriceCalculator!=''"
                            class="w-auto flex justify-content-end">
                            <a [href]="institute?.netPriceCalculator" target="_blank"
                                class="w-auto font-regular text-sm text-white hover:bg-blue-700 border-round-lg "
                                style="padding: 12px 16px; background-color: #000086;">Net price calculator</a>
                        </div>
                    </div>

                    <div class="flex gap-3 md:gap-6 flex-column  md:flex-row">
                        <div class="flex-1 flex flex-column gap-3">

                            <div class="flex flex-column">
                                <div
                                    class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                                    <p class="text-base font-semibold text-bluegray-600">Median Household Income
                                    <p>
                                    <p class="text-base font-semibold font-medium" style="color: #12263F;">{{
                                        getAmount(instituteUGMDetails.currency,
                                        ( instituteUGMDetails.medianFamilyIncome ?? 0) || 0) }}</p>
                                </div>
                                <div
                                    class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                                    <p class="text-base font-semibold text-bluegray-600">Application Fee</p>
                                    <p class="text-base font-semibold font-medium" style="color: #12263F;">{{
                                        getAmount(instituteUGMDetails.currency,
                                        ( instituteUGMDetails.applicationFees ?? 0) || 0) }}</p>
                                </div>

                                <div
                                    class="flex align-items-center justify-content-between border-top-1 border-300 pt-3">
                                    <p class="text-base font-semibold text-bluegray-600">Food & Housing Charges</p>
                                    <p class="text-base font-semibold font-medium" style="color: #12263F;">{{
                                        getAmount(instituteUGMDetails.currency,
                                        ( instituteUGMDetails.combinedFoodAndHousingCharge ?? 0) || 0) }}</p>
                                </div>

                            </div>
                        </div>
                        <div class="flex-1 flex flex-column gap-3">
                            <div class="flex flex-column">
                                <b class="text-left font-bold text-2xl mb-3 " style="color:#101010">Scholarships</b>
                                <a [routerLink]="'/portal/scholarships'"
                                    class="w-full h-3rem border-round-lg text-center font-medium text-base font-semibold link"
                                    style="line-height: 48px;  color: #101010;">Find Scholarship Information</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="selectedProgramType === 'Bachelor\'s Degree' && isUGDetails(instituteUGMDetails)" id="divCost"
    class="w-full  mt-3  flex flex-column border-1 border-300 border-round-lg align-items-center">
    <div class="flex flex-column gap-3 w-full p-4">
        <h2 class="text-left text-xl font-medium" style="color: #000086;">Cost</h2>
        <div class="flex gap-6 flex-column md:flex-row">
            <div class="flex-1 flex flex-column gap-3">
                <div class="flex flex-column gap-3">

                    <div class="flex align-items-center justify-content-between gap-2">
                        <div class="flex flex-column gap-1">
                            <p class="text-base font-semibold font-medium text-bluegray-600">Net Price</p>
                            <b class="text-2xl font-bold">{{ getAmount(instituteUGMDetails.currency,
                                ( instituteUGMDetails.averageTutionFees ?? 0) || 0) }}</b>
                        </div>
                        <div *ngIf="institute?.netPriceCalculator && institute?.netPriceCalculator!=''"
                            class="w-auto flex justify-content-end">
                            <a [href]="getExternalUrl(institute?.netPriceCalculator)" target="_blank"
                                class="w-auto font-regular text-sm text-white hover:bg-blue-700 border-round-lg "
                                style="padding: 12px 16px; background-color: #000086;">Net price calculator</a>
                        </div>
                    </div>

                    <div class="flex gap-3 md:gap-6 flex-column  md:flex-row">
                        <div class="flex-1 flex flex-column gap-3">

                            <div class="flex flex-column">
                                <!-- <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                        <p class="text-sm text-bluegray-600">Average Cost of Attendance</p>
                        <p class="text-sm font-medium" style="color: #12263F;">{{ getAmount(instituteUGMDetails.currency,
                    ( instituteUGMDetails.averageCostOfAttendance ?? 0) || 0) }}
                        </p>
                    </div> -->
                                <div
                                    class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                                    <p class="text-base font-semibold text-bluegray-600">Estimated books and supplies
                                    </p>
                                    <p class="text-base font-semibold font-medium" style="color: #12263F;">{{
                                        getAmount(instituteUGMDetails.currency,
                                        ( instituteUGMDetails.estimatedBooksAndSupplies ?? 0) || 0) }}</p>
                                </div>
                                <div
                                    class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                                    <p class="text-base font-semibold text-bluegray-600">On-campus room and board</p>
                                    <p class="text-base font-semibold font-medium" style="color: #12263F;">{{
                                        getAmount(instituteUGMDetails.currency,
                                        ( instituteUGMDetails.onCampusRoomAndBoard ?? 0) || 0) }}</p>
                                </div>
                                <!-- <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                        <p class="text-sm text-bluegray-600">On-campus Other Expenses</p>
                        <p class="text-sm font-medium" style="color: #12263F;">{{ getAmount(instituteUGMDetails.currency,
                    ( instituteUGMDetails.onCampusOtherExpenses ?? 0) || 0) }}</p>
                    </div> -->
                                <div
                                    class="flex align-items-center justify-content-between border-top-1 border-300 pt-3">
                                    <p class="text-base font-semibold text-bluegray-600">Off-campus room and board</p>
                                    <p class="text-base font-semibold font-medium" style="color: #12263F;">{{
                                        getAmount(instituteUGMDetails.currency,
                                        ( instituteUGMDetails.offCampusRoomAndBoard ?? 0) || 0) }}</p>
                                </div>
                                <!-- <div class="flex align-items-center justify-content-between border-top-1 border-300 pt-3">
                        <p class="text-sm text-bluegray-600">Off-campus Other Expenses</p>
                        <p class="text-sm font-medium" style="color: #12263F;">{{ getAmount(instituteUGMDetails.currency,
                    ( instituteUGMDetails.offCampusOtherExpenses ?? 0) || 0) }}</p>
                    </div>
                    <div class="flex align-items-center justify-content-between border-top-1 border-300 pt-3">
                        <p class="text-sm text-bluegray-600">Housing Capacity</p>
                        <p class="text-sm font-medium" style="color: #12263F;">{{  instituteUGMDetails.housingCapacity ?? 0 }}</p>
                    </div>
                    <div class="flex align-items-center justify-content-between border-top-1 border-300 pt-3">
                        <p class="text-sm text-bluegray-600">Median family Income</p>
                        <p class="text-sm font-medium" style="color: #12263F;">{{ getAmount(instituteUGMDetails.currency,
                    ( instituteUGMDetails.medianFamilyIncome ?? 0) || 0) }}</p>
                    </div> -->
                            </div>
                        </div>
                        <div class="flex-1 flex flex-column gap-3">
                            <div class="flex flex-column">
                                <b class="text-left font-bold text-2xl mb-4 " style="color:#101010">Scholarships</b>
                                <div
                                    class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                                    <p class="text-base font-semibold text-bluegray-600">Average Total Aid Awarded</p>
                                    <p class="text-base font-semibold font-medium" style="color: #12263F;">{{
                                        getAmount(instituteUGMDetails.currency,
                                        (
                                        instituteUGMDetails.averageFirstTimeFullTimeUndergradsAwardedInstitutionalGrant
                                        ?? 0) || 0) }}</p>
                                </div>
                                <div
                                    class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                                    <p class="text-base font-semibold text-bluegray-600">Students Receiving Financial
                                        Aid</p>
                                    <p class="text-base font-semibold font-medium" style="color: #12263F;">
                                        {{
                                        stringToPercent(instituteUGMDetails.percentFirstTimeFullTimeUndergradsAwardedInstitutionalGrant
                                        || 0) }}%</p>
                                </div>
                                <a [routerLink]="'/portal/scholarships'"
                                    class="w-full h-3rem border-round-lg text-center font-medium text-base font-semibold link"
                                    style="line-height: 48px;  color: #101010;">Find Scholarship Information</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="selectedProgramType === 'Bachelor\'s Degree' && isUGDetails(instituteUGMDetails)" id="divScholarship"
    class="w-full mt-3  flex flex-column border-1 border-300 border-round-lg align-items-center">
    <div class="flex flex-column gap-3 w-full p-4">
        @if (scholarships.length > 0) {
        <h2 class="text-left text-xl font-medium" style="color: #000086;">Scholarships</h2>

        <!-- <div class="flex flex-column gap-1">
                <p class="text-base font-semibold font-medium text-bluegray-600">Graduate Schools within</p>
            </div> -->
        @for (item of visibleScholarships; track $index) {
        <div class="flex flex-column gap-2">
            <a class="w-full h-auto px-3 py-2 border-round-lg font-medium text-base font-semibold link_scholarship"
                style="color: #101010; white-space: normal; word-wrap: break-word; background-color: #d1c4e9;">
                {{ item }}
            </a>
        </div>
        }
        <!-- <p-accordion class="w-full">
                <p-accordionTab header="More" iconPos="end" headerStyleClass="header_tab"
                contentStyleClass="tab_content">
                <div class="flex flex-column gap-3 w-full pt-2">
                    @for (item of (instituteUGMDetails.findScholarships  || []).slice(3); track $index) {
                        <div class="flex flex-column gap-2">
                            <a class="w-full h-3rem px-3 border-round-lg font-medium text-base font-semibold link_scholarship " style="line-height: 48px; color: #101010;">{{item}}</a>    
                        </div>
                    }
                </div>
                </p-accordionTab>
            </p-accordion> -->
        <div *ngIf="scholarships.length > 3" class="mt-2 flex justify-content-end">
            <button
                class=" text-base font-semibold border-none border-round cursor-pointer hover:underline text-blue-600 bg-transparent"
                (click)="toggleScholarshipsView()">
                {{ showAllScholarships ? 'Show Less' : 'View All Scholarships' }}
            </button>
        </div>
        }@else {
        <h2 class="text-left text-xl text-bluegray-600 font-medium" style="color: #000086;">Scholarships</h2>
        }
    </div>
</div>


<div id="divScholarship" class="w-full mt-3  flex flex-column border-1 border-300 border-round-lg align-items-center">
    <div class="flex flex-column gap-3 w-full p-4">
        @if (graduateSchoolsWithin.length > 0) {
        <h2 class="text-left text-xl font-medium" style="color: #000086;">Graduate Schools Within</h2>

        <!-- <div class="flex flex-column gap-1">
                <p class="text-base font-semibold font-medium text-bluegray-600">Graduate Schools within</p>
            </div> -->
        @for (item of visibleGraduateSchoolsWithin; track $index) {
        <div class="flex flex-column gap-2">
            <a class="w-full h-3rem px-3 border-round-lg font-medium text-base font-semibold link_scholarship "
                style="line-height: 48px; color: #101010;">{{item.graduateSchoolName}}</a>
        </div>
        }
        <!-- <p-accordion class="w-full">
            <p-accordionTab [header]="accordionHeaderText"
            
            iconPos="end" headerStyleClass="header_tab"
            contentStyleClass="tab_content">
            <div class="flex flex-column gap-3 w-full pt-2">
                @for (item of (graduateSchoolsWithin || []).slice(3); track $index) {
                    <div class="flex flex-column gap-2">
                        <a class="w-full h-3rem px-3 border-round-lg font-medium text-base font-semibold link_scholarship " style="line-height: 48px; color: #101010;">{{item.graduateSchoolName}}</a>    
                    </div>
                }
            </div>
            </p-accordionTab>
        </p-accordion> -->
        <div *ngIf="graduateSchoolsWithin.length > 3" class="mt-2 flex justify-content-end">
            <button
                class=" text-base font-semibold border-none border-round cursor-pointer hover:underline text-blue-600 bg-transparent"
                (click)="toggleGraduateSchoolsView()">
                {{ showAllGraduateSchoolsWithin ? 'Show Less' : 'View All Graduate Schools' }}
            </button>
        </div>
        }@else {
        <h2 class="text-left text-xl text-bluegray-600 font-medium" style="color: #000086;">No Graduate Schools Within!
        </h2>
        }
    </div>
</div>

<!-- <div id="divStudents" class="w-full  mt-3 flex border-1 border-300 border-round-lg">
    <div class="flex flex-column gap-3 w-full p-4">
    <h2 class="text-left text-xl font-medium" style="color: #000086;">Students</h2>
    <div class="flex flex-column">
        <div class="flex align-items-center justify-content-between border-y-1 border-300 py-3">
        <p class="text-sm text-bluegray-600">Total fulltime students enrolled</p>
        <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails?.fullTimeEnrollment != 0 ?
            instituteUGMDetails?.fullTimeEnrollment : ''}}</p>
        </div>
        <div class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3"
        *ngIf="instituteUGMDetails?.internationStudentsEnrollment != null">
        <p class="text-sm text-bluegray-600">International students enrolled</p>
        <p class="text-sm font-medium" style="color: #12263F;">
            {{instituteUGMDetails?.internationStudentsEnrollment}}</p>
        </div>
        <div class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3"
        *ngIf="instituteUGMDetails?.graduateStudentsEnrolled != null">
        <p class="text-sm text-bluegray-600">Graduate enrollment</p>
        <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails?.graduateStudentsEnrolled !=
            0 ? instituteUGMDetails?.graduateStudentsEnrolled : ''}}</p>
        </div>
        <div class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3"
        *ngIf="instituteUGMDetails?.maleEnrollment != null">
        <p class="text-sm text-bluegray-600">Male enrollment</p>
        <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails?.maleEnrollment}}</p>
        </div>
        <div class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3"
        *ngIf="instituteUGMDetails?.femaleEnrollment != null">
        <p class="text-sm text-bluegray-600">Female enrollment</p>
        <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails?.femaleEnrollment}}</p>
        </div>
    </div>
    </div>
    <div class="flex flex-column align-items-center justify-content-center p-4">
    @if(pieData){
    <p-chart type="pie" [data]="pieData" [options]="pieOptions" />
    }
    </div>
</div> -->

<div *ngIf="selectedProgramType === 'Master\'s Degree' && isMastersDetails(instituteUGMDetails)" id="divStudents"
    class="w-full  mt-3 ">
    <div class="grid grid-nogutter border-1 border-300 border-round-lg p-4">
        <div class="md:col-6 col-12 flex flex-column gap-3">
            <h2 class="text-left text-xl font-medium" style="color: #000086;">Student & Enrollments</h2>
            <div class="flex flex-column">
                <div class="flex flex-column gap-1 pb-3">
                    <p class="text-base font-semibold text-bluegray-600">Graduate Enrollments</p>
                    <b class="text-2xl font-bold">{{instituteUGMDetails.graduateStudentsEnrolled | number}} <span
                            class="text-sm text-bluegray-600">Grads</span></b>
                </div>
                <!-- <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                    <p class="text-sm text-bluegray-600">Full Time Enrollments</p>
                    <p class="text-sm font-medium" style="color: #12263F;">N/A</p>
                </div> -->
                <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">Part Time Enrollments</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">
    {{ getPercentOf(instituteUGMDetails.partTimeEnrollment, instituteUGMDetails.graduateStudentsEnrolled) }}</p>
                    <!-- <p class="text-base font-semibold font-medium" style="color: #12263F;">
                        {{instituteUGMDetails.partTimeEnrollment | number}}</p> -->
                </div>
                <!-- <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                    <p class="text-sm text-bluegray-600">Graduate Assistant total</p>
                    <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.graduateAssistantTotal}}</p>
                </div> -->
                <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">Teaching Assistants</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">
    {{ getPercentOf(instituteUGMDetails.graduateAssistantsTeaching, instituteUGMDetails.graduateStudentsEnrolled) }}</p>
                    <!-- <p class="text-base font-semibold font-medium" style="color: #12263F;">
                        {{instituteUGMDetails.graduateAssistantsTeaching | number}}</p> -->
                </div>
                <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">Research Assistants</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">
    {{ getPercentOf(instituteUGMDetails.graduateAssistantsResearch, instituteUGMDetails.graduateStudentsEnrolled) }}</p>
                    <!-- <p class="text-base font-semibold font-medium" style="color: #12263F;">
                        {{instituteUGMDetails.graduateAssistantsResearch | number}}</p> -->
                </div>
                <!-- <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                    <p class="text-sm text-bluegray-600">American Indian or Alaska Native</p>
                    <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.americanIndianOrAlaskaNative}}</p>
                </div>
                <div class="flex align-items-center justify-content-between border-top-1 border-300 pt-3">
                    <p class="text-sm text-bluegray-600">Asian Student’s Enrolled</p>
                    <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.asian}}</p>
                </div>
                <div class="flex align-items-center justify-content-between border-top-1 border-300 pt-3">
                    <p class="text-sm text-bluegray-600">Black or African American Student’s Enrolled</p>
                    <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.blackOrAfricanAmerican}}</p>
                </div>
                <div class="flex align-items-center justify-content-between border-top-1 border-300 pt-3">
                    <p class="text-sm text-bluegray-600">Hispanic/Latino Student’s Enrolled</p>
                    <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.hispanicOrLatino}}</p>
                </div>
                <div class="flex align-items-center justify-content-between border-top-1 border-300 pt-3">
                    <p class="text-sm text-bluegray-600">Native Hawaiian or Other Pacific Islander Student’s Enrolled</p>
                    <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.nativeHawaiianOrOtherPacificIslander}}</p>
                </div>
                <div class="flex align-items-center justify-content-between border-top-1 border-300 pt-3">
                    <p class="text-sm text-bluegray-600">White Student’s Enrolled</p>
                    <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.white}}</p>
                </div>
                <div class="flex align-items-center justify-content-between border-top-1 border-300 pt-3">
                    <p class="text-sm text-bluegray-600">Two or more races</p>
                    <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.twoOrMoreRaces}}</p>
                </div>
                <div class="flex align-items-center justify-content-between border-top-1 border-300 pt-3">
                    <p class="text-sm text-bluegray-600">International student Student’s Enrolled</p>
                    <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.internationalStudents}}</p>
                </div>
                <div class="flex align-items-center justify-content-between border-top-1 border-300 pt-3">
                    <p class="text-sm text-bluegray-600">Race/ethnicity unknown</p>
                    <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.raceOrEthnicityUnknown}}</p>
                </div> -->
            </div>
        </div>
        <div class="md:col-6 col-12 pt-4 md:pt-0 flex flex-column align-items-center justify-content-center">
            @if(pieData){
            <p-chart type="pie" [data]="pieData" [options]="pieOptions" />
            }
        </div>
    </div>
</div>

<div *ngIf="selectedProgramType === 'Bachelor\'s Degree' && isUGDetails(instituteUGMDetails)" id="divStudents"
    class="w-full  mt-3 ">
    <div class="grid grid-nogutter border-1 border-300 border-round-lg p-4">
        <div class="md:col-6 col-12 flex flex-column gap-3">
            <h2 class="text-left text-xl font-medium" style="color: #000086;">Student & Enrollments</h2>
            <div class="flex flex-column">
                <div class="flex flex-column gap-1 pb-3">
                    <p class="text-base font-semibold text-bluegray-600">Full Time Enrollments</p>
                    <b class="text-2xl font-bold">{{instituteUGMDetails.fullTimeEnrollment === 0 ? 'N/A'
                        :instituteUGMDetails.fullTimeEnrollment | number}} <span
                            class="text-sm text-bluegray-600">Grads</span></b>
                </div>
                <!-- <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                <p class="text-sm text-bluegray-600">Full Time Enrollments</p>
                <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.fullTimeEnrollment}}</p>
            </div> -->
                <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">Male Enrollment</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">
    {{ formatPercent(instituteUGMDetails.maleEnrollment) }}</p>
                </div>
                <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">Female Enrollment</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">
    {{ formatPercent(instituteUGMDetails.femaleEnrollment) }}</p>
                </div>
                <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">International Students</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">
    {{ formatPercent(instituteUGMDetails.internationStudentsEnrollment) }}</p>
                </div>
                <!-- <div class="flex align-items-center justify-content-between border-top-1 border-300 pt-3">
                <p class="text-sm text-bluegray-600">White Student’s Enrolled</p>
                <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.white}}</p>
            </div>
            <div class="flex align-items-center justify-content-between border-top-1 border-300 pt-3">
                <p class="text-sm text-bluegray-600">Black Student’s Enrolled</p>
                <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.black}}</p>
            </div>
            <div class="flex align-items-center justify-content-between border-top-1 border-300 pt-3">
                <p class="text-sm text-bluegray-600">Hispanic Student’s Enrolled</p>
                <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.hispanic}}</p>
            </div>
            <div class="flex align-items-center justify-content-between border-top-1 border-300 pt-3">
                <p class="text-sm text-bluegray-600">Asian Student’s Enrolled</p>
                <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.asian}}</p>
            </div>
            <div class="flex align-items-center justify-content-between border-top-1 border-300 pt-3">
                <p class="text-sm text-bluegray-600">American Indian/Alaska Native Student’s Enrolled</p>
                <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.americanIndianOrAlaskaNative}}</p>
            </div>
            <div class="flex align-items-center justify-content-between border-top-1 border-300 pt-3">
                <p class="text-sm text-bluegray-600">Native Hawaiian/Pacific Islander Student’s Enrolled</p>
                <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.nativeHawaiianOrOtherPacificIslander}}</p>
            </div>
            <div class="flex align-items-center justify-content-between border-top-1 border-300 pt-3">
                <p class="text-sm text-bluegray-600">Two or more races</p>
                <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.twoOrMoreRaces}}</p>
            </div>
            <div class="flex align-items-center justify-content-between border-top-1 border-300 pt-3">
                <p class="text-sm text-bluegray-600">Unknown Race Student’s Enrolled</p>
                <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.raceOrEthnicityUnknown}}</p>
            </div> -->
            </div>
        </div>
        <div class="md:col-6 col-12 pt-4 md:pt-0 flex flex-column align-items-center justify-content-center">
            @if(pieData){
            <p-chart type="pie" [data]="pieData" [options]="pieOptions" />
            }
        </div>
    </div>
</div>


<div *ngIf="selectedProgramType === 'Bachelor\'s Degree' && isUGDetails(instituteUGMDetails)" id="divAcademics"
    class="w-full mt-3  flex flex-column border-1 border-300 border-round-lg align-items-center">
    <div class="flex flex-column gap-3 w-full p-4">
        <h2 class="text-left text-xl font-medium" style="color: #000086;">Academics</h2>
        <!-- <div class="flex flex-column sm:flex-row gap-1 align-content-center md:gap-3">
        <a href="#" class="h-3rem flex-1 text-center border-round-lg link_aa" style="line-height: 48px; color: #fff;">Find Undergraduate Courses</a>
        <a href="#" class="h-3rem flex-1 text-center border-round-lg link_aay" style="line-height: 48px; color: #101010;">Find Graduate Courses</a>
    </div> -->
        <div class="w-full grid grid-nogutter align-items-center">
            <div class="col-12 md:col-6">
                <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">Student Faculty Ratio</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">
                        {{instituteUGMDetails.studentFacultyRatio}}</p>
                </div>
                <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">International Faculty</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">
                        {{ formatPercent(instituteUGMDetails.fullTimeUSNonResidentFacultyShare) }}</p>
                </div>
                <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">Graduation Rate Faculty</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">
                       {{ formatPercent(instituteUGMDetails.totalCohortGraduationRate) }}</p>
                </div>
                <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">International Student Graduation Rate</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">
                        {{ formatPercent(instituteUGMDetails.internationalStudentsGraduationRate) }}</p>
                </div>
                <!-- <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                <p class="text-sm text-bluegray-600">Proportion of faculty that is full time</p>
                <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.fullTimeFacultyProportion}}</p>
            </div> -->
            </div>
            <div class="col-12 md:col-6">
                <div class="flex flex-column gap-1 pt-4 md:pt-0 md:pl-4">
                    <a (click)="triggerDisplayCourses()" class="h-3rem flex-1 text-center border-round-lg link_aa"
                        style="line-height: 48px; color: #fff;">Find Undergraduate Courses</a>
                    <a (click)="triggerDisplayCourses()" class="h-3rem flex-1 text-center border-round-lg link_aay"
                        style="line-height: 48px; color: #101010;">Find Graduate Courses</a>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="(selectedProgramType === 'Bachelor\'s Degree' || selectedProgramType === 'Master\'s Degree')" id="divMajors"
    class="w-full  mt-3 flex flex-column border-1 border-300 border-round-lg align-items-center">
    <div class="w-full p-4 flex flex-column gap-3">
        <h2 class="text-left text-xl font-medium" style="color: #000086;">Majors</h2>
        <div *ngIf="selectedProgramType === 'Bachelor\'s Degree'">
            @if (instituteBachelorMajors.length > 0) {
            <h1 class="text-left text-2xl font-bold">Most Popular Undergraduate Majors</h1>
            <div class="flex flex-column">
                @for (major of visibleUGMajors ; track $index) {
                <div class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">{{major.fieldOfStudy}}</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">{{major.numberOfGraduates |
                        number}} Graduates</p>
                </div>
                }

                <!-- <div class="flex align-items-center justify-content-between border-300 pt-3">
                <p-accordion class="w-full">
                    <p-accordionTab header="More" iconPos="end" headerStyleClass="header_tab"
                    contentStyleClass="tab_content">
                    <div class="flex flex-column pt-3 ">
                    @for (major of (instituteBachelorMajors || []).slice(3); track major) {
                        <div class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
                        <p class="text-base font-semibold text-bluegray-600">{{major.fieldOfStudy}}</p>
                        <p class="text-base font-semibold font-medium" style="color: #12263F;">{{major.numberOfGraduates  | number}} Graduates</p>
                        </div>
                    }
                    </div>
                    </p-accordionTab>
                </p-accordion>
                </div> -->
            </div>
            <div *ngIf="instituteBachelorMajors.length > 3" class="mt-2 flex justify-content-end">
                <button
                    class=" py-2 text-base font-semibold border-none border-round cursor-pointer hover:underline text-blue-600 bg-transparent"
                    (click)="toggleMajorsView('UG')">
                    {{ showAllUGMajors ? 'Show Less' : 'View All Majors' }}
                </button>
            </div>
            }@else {
            <h1 class="text-left text-2xl mt-1 font-bold text-bluegray-600">No Undergraduate Majors Available!</h1>
            }
        </div>
        <div *ngIf="selectedProgramType === 'Master\'s Degree'">
            @if (instituteGraduateMajors.length > 0) {
            <h1 class="text-left text-2xl font-bold">Most Popular Postgraduate Majors</h1>
            <div class="flex flex-column">
                @for (major of visiblePGMajors ; track $index) {
                <div class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">{{major.fieldOfStudy}}</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">{{major.numberOfGraduates |
                        number}} Graduates</p>
                </div>
                }
                <!-- <div class="flex align-items-center justify-content-between border-300 pt-3">
                <p-accordion class="w-full">
                    <p-accordionTab header="More" iconPos="end" headerStyleClass="header_tab"
                    contentStyleClass="tab_content">
                    <div class="flex flex-column pt-3 ">
                    @for (major of (instituteGraduateMajors || []).slice(3); track major) {
                        <div class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
                        <p class="text-base font-semibold text-bluegray-600">{{major.fieldOfStudy}}</p>
                        <p class="text-base font-semibold font-medium" style="color: #12263F;">{{major.numberOfGraduates | number}} Graduates</p>
                        </div>
                    }
                    </div>
                    </p-accordionTab>
                </p-accordion>
                </div> -->
            </div>
            <div *ngIf="instituteGraduateMajors.length > 3" class="mt-2 flex justify-content-end">
                <button
                    class=" py-2 text-base font-semibold border-none border-round cursor-pointer hover:underline text-blue-600 bg-transparent"
                    (click)="toggleMajorsView('PG')">
                    {{ showAllPGMajors ? 'Show Less' : 'View All Majors' }}
                </button>
            </div>
            }@else {
            <h1 class="text-left text-2xl mt-1 font-bold text-bluegray-600">No Postgraduate Majors Available!</h1>
            }

            @if (instituteDoctoralMajors.length > 0) {
            <h1 class="text-left text-2xl mt-1 font-bold">Most Popular Doctoral Majors</h1>
            <div class="flex flex-column">
                @for (major of visibleDoctoralMajors ; track major) {
                <div class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">{{major.fieldOfStudy}}</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">{{major.numberOfGraduates |
                        number}} Graduates</p>
                </div>
                }
                <!-- <div class="flex align-items-center justify-content-between border-300 pt-3">
                <p-accordion class="w-full">
                    <p-accordionTab header="More" iconPos="end" headerStyleClass="header_tab"
                    contentStyleClass="tab_content">
                    <div class="flex flex-column pt-3 ">
                    @for (major of (instituteDoctoralMajors || []).slice(3); track major) {
                        <div class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
                        <p class="text-base font-semibold text-bluegray-600">{{major.fieldOfStudy}}</p>
                        <p class="text-base font-semibold font-medium" style="color: #12263F;">{{major.numberOfGraduates | number}} Graduates</p>
                        </div>
                    }
                    </div>
                    </p-accordionTab>
                </p-accordion>
                </div> -->
            </div>
            <div *ngIf="instituteDoctoralMajors.length > 3" class="mt-2 flex justify-content-end">
                <button
                    class=" py-2 text-base font-semibold border-none border-round cursor-pointer hover:underline text-blue-600 bg-transparent"
                    (click)="toggleMajorsView('Doctoral')">
                    {{ showAllDoctoralMajors ? 'Show Less' : 'View All Majors' }}
                </button>
            </div>
            }@else{
            <h1 class="text-left text-2xl mt-1 font-bold text-bluegray-600">No Doctoral Majors Available!</h1>
            }
        </div>

    </div>
</div>



<div *ngIf="selectedProgramType !== 'Alumni'" id="divAfterCollege" class="w-full mt-3  flex flex-column border-1 border-300 border-round-lg align-items-center">
    <div class="flex flex-column gap-3 w-full p-4">
        <h2 class="text-left text-xl font-medium" style="color: #000086;">After College</h2>
        <div class="grid grid-nogutter align-items-end">
            <div *ngIf="isUGDetails(instituteUGMDetails)" class="md:col-4 col-12">
                <div class="flex flex-column gap-1 pb-3 md:pb-0 md:pr-3">
                    <p class="text-sm text-bluegray-600">Median Earnings after 1 year</p>
                    <b class="text-2xl font-bold">{{ getAmount(instituteUGMDetails.currency,
                        ( instituteUGMDetails.medianEarningsOfGraduatesWorkingPostOneYearCompletion ?? 0) || 0) }} <span
                            class="text-sm text-bluegray-600"> / per year</span></b>
                </div>
            </div>

            <div *ngIf="isUGDetails(instituteUGMDetails)" class="md:col-4 col-12">
                <div class="flex flex-column gap-1 pb-3 md:pb-0 md:pr-3">
                    <p class="text-sm text-bluegray-600">Median Earnings after 5 years </p>
                    <b class="text-2xl font-bold">{{ getAmount(instituteUGMDetails.currency,
                        ( instituteUGMDetails.medianEarningsOfGraduatesWorkingPostFiveYearCompletion ?? 0) || 0) }}<span
                            class="text-sm text-bluegray-600"> / per year</span></b>
                </div>
            </div>
            <div class="md:col-8 col-12 mt-1">
                <div class="flex flex-column gap-1 pb-3 md:pb-0 md:pr-3">
                    <p class="text-sm text-bluegray-600">Popular Employers</p>
                    <b class="text-2xl font-bold">{{popularEmployers ? popularEmployers: 'N/A'}}</b>
                </div>
            </div>
            <!-- <div *ngIf="isUGDetails(instituteUGMDetails)" class="md:col-4 col-12">
            <div class="flex flex-column gap-1 pb-3 md:pb-0 md:pr-3">
                <p class="text-sm text-bluegray-600">Graduation rate for international students 2023 </p>
                <b class="text-2xl font-bold">{{instituteUGMDetails.internationalStudentsGraduationRate}}</b>
            </div>
        </div> -->
            <!-- <div *ngIf="isUGDetails(instituteUGMDetails)" class="md:col-4 col-12">
            <div class="flex flex-column gap-1 pb-3 md:pb-0 md:pr-3">
                <p class="text-sm text-bluegray-600">Graduation rate for total cohort </p>
                <b class="text-2xl font-bold">{{instituteUGMDetails.totalCohortGraduationRate}}</b>
            </div>
        </div> -->

            <!-- <div *ngIf="isUGDetails(instituteUGMDetails)" class="md:col-4 col-12">
            <div class="flex flex-column gap-1 pb-3 md:pb-0 md:pr-3">
                <p class="text-sm text-bluegray-600">Students earning more than a high school graduate (threshold earnings) 11 years after entry </p>
                <b class="text-2xl font-bold">{{instituteUGMDetails.percentEarningAboveHighSchool11Years}}</b>
            </div>
        </div> -->
            <div class="md:col-4 col-12">
                <a [routerLink]="'/portal/peer'" class="h-3rem block flex-1 text-center border-round-lg link_aay"
                    style="line-height: 48px; color: #101010;">Connect with Alumni</a>
            </div>
        </div>
    </div>
</div>